import { getBoostTAE, type IBoostTAE } from '@boost/widget-integration-tae/lib';
import { Injectable } from 'framework/di';

import { Platform } from '../platform.interface';
import { ShopifyRouter } from './router';

@Injectable
export class ShopifyPlatform implements Platform {
  constructor(private shopifyRouter: ShopifyRouter) {}

  get TAE(): IBoostTAE {
    return getBoostTAE();
  }

  get router() {
    return this.shopifyRouter;
  }

  get customer() {
    const id =
      window?.__st?.cid ||
      window?.meta?.page?.customerId ||
      (window?.ShopifyAnalytics as any)?.meta?.page?.customerId ||
      (window?.ShopifyAnalytics as any)?.lib?.user?.()?.traits?.()?.uniqToken;

    if (!id) return undefined;

    return {
      id,
    };
  }

  get collection() {
    let collectionId: string | number = 0;

    if (this.shopifyRouter.page === 'collection') {
      collectionId = this.TAE.config.generalSettings.collection_id || 0;
    }

    return {
      id: collectionId,
    };
  }

  get product() {
    const productId = this.TAE.config.generalSettings.product_id;

    if (!productId) return;

    return {
      id: productId,
    };
  }

  get localization() {
    return {
      locale: window.Shopify?.locale,
      country: window.Shopify?.country,
    };
  }

  get currency() {
    return {
      rate: window.Shopify?.currency?.rate,
      active: window.Shopify?.currency?.active,
    };
  }
}
